import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { NewsletterForm } from "@/components/site/NewsletterForm";
import { Vote, Fish, Wrench, Building2, FlaskConical, Briefcase } from "lucide-react";

const INFLUENCE = [
  { icon: Fish, label: "Fish projects" },
  { icon: Vote, label: "Breeding decisions" },
  { icon: Wrench, label: "Equipment choices" },
  { icon: Building2, label: "Fish room developments" },
  { icon: FlaskConical, label: "Product testing" },
  { icon: Briefcase, label: "Business decisions" },
];

export const CommunitySection = () => {
  return (
    <section className="py-24 lg:py-32 bg-brand-surface" data-testid="community-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <SectionLabel>Community</SectionLabel>
            <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              BUILD IT WITH ME
            </h2>
            <p className="mt-6 text-brand-textSec leading-relaxed">
              The audience is an important part of the project. As it grows, viewers will help influence the
              direction of everything below.
            </p>
            <p className="mt-6 font-display font-bold text-xl text-brand-cyan leading-snug">
              You're not just watching the project. You're helping build it.
            </p>
            <div className="mt-8">
              <NewsletterForm />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="grid grid-cols-2 gap-4">
              {INFLUENCE.map(({ icon: Icon, label }) => (
                <div key={label} className="card-surface p-6" data-testid={`influence-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                  <span className="h-10 w-10 grid place-items-center rounded-full bg-brand-cyan/10 text-brand-cyan mb-4">
                    <Icon size={20} />
                  </span>
                  <p className="text-white font-medium text-sm">{label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
